import { Chip, Tooltip } from '@mui/material';
import { formatTimestamp } from '@/utils/date/date';

const ClientBankAccountStatus = ({ deactivatedAt }) => {
  const isActive = !deactivatedAt;

  if (isActive) {
    return (
      <Chip
        label='Active'
        color='success'
        size='small'
        sx={{ fontWeight: 500 }}
      />
    );
  }

  return (
    <Tooltip title={`Deactivated on ${formatTimestamp(deactivatedAt)}`} arrow>
      <Chip
        label='Inactive'
        color='default'
        size='small'
        sx={{ fontWeight: 500 }}
      />
    </Tooltip>
  );
};

export default ClientBankAccountStatus;
